export default __webpack_public_path__ + "static/media/abusd.c9e33dd3.svg";